import { NavLink } from "react-router-dom";
import ToolTip from "../Tooltip";
import { navIcons } from "../../images";

export default function SidebarNavGroupItem(props) {
  const { collapsed, tooltipText, label, iconComponent, url, externalUrl } =
    props;

  const Icon = iconComponent || <navIcons.Dashboard />;
  const linkContent = (
    <>
      <span className="tw-flex">{Icon}</span>
      <span className={`tw-flex-1 ${collapsed ? "lg:tw-hidden" : ""}`}>
        {label}
      </span>
    </>
  );

  return (
    <ToolTip
      className="tw-hidden lg:tw-block"
      disabled={!collapsed}
      content={tooltipText}
      config={{
        arrow: true,
        placement: "right",
      }}
    >
      <li>
        {externalUrl ? (
          <a
            href={externalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="side-nav-link"
          >
            {linkContent}
          </a>
        ) : (
          <NavLink
            to={url}
            className="side-nav-link"
            exact
            activeClassName="active"
          >
            {linkContent}
          </NavLink>
        )}
      </li>
    </ToolTip>
  );
}
